import { render, staticRenderFns } from "./ds-icon.vue?vue&type=template&id=5d78d5d0&"
import script from "./ds-icon.vue?vue&type=script&lang=ts&"
export * from "./ds-icon.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports